import { render } from "./RetiradaForm.vue?vue&type=template&id=3f1d4afd"
import script from "./RetiradaForm.vue?vue&type=script&lang=js"
export * from "./RetiradaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__